import type { PortalNotificadoListItem } from '../types/portalTypes';

import type { RootState } from '@/store';

export const selectPortalIsAuthenticated = (state: RootState) => state.portal.isAuthenticated;

export const selectPortalUser = (state: RootState) => state.portal.user;

export const selectPortalToken = (state: RootState) => state.portal.token;

export const selectPortalCurrentNotificacao = (state: RootState) => state.portal.currentNotificacao;

export const selectPortalSessaoId = (state: RootState) => state.portal.sessaoId;

export const selectPortalLoading = (state: RootState) => state.portal.loading;

export const selectPortalError = (state: RootState) => state.portal.error;

export const selectPortalPagination = (state: RootState) => state.portal.pagination;

export const selectPortalFilters = (state: RootState) => state.portal.filters;

export const selectPortalNotificacoesNaoLidas = (state: RootState) =>
  state.portal.notificacoes.filter((n: PortalNotificadoListItem) => !n.foiLida);

export const selectPortalNotificacoesCount = (state: RootState) => state.portal.notificacoes.length;

export const selectPortalFaqItems = (state: RootState) => state.portal.faqItems;
export const selectPortalFaqLoading = (state: RootState) => state.portal.faqLoading;

export const selectAlterarContato = (state: RootState) => state.portal.alterarContato;
export const selectAlterarContatoEtapa = (state: RootState) => state.portal.alterarContato.etapa;
export const selectAlterarContatoTipo = (state: RootState) =>
  state.portal.alterarContato.tipoContato;
export const selectAlterarContatoVerificationId = (state: RootState) =>
  state.portal.alterarContato.verificationId;
export const selectAlterarContatoVerificationUrl = (state: RootState) =>
  state.portal.alterarContato.verificationUrl;
export const selectAlterarContatoCooldownUntil = (state: RootState) =>
  state.portal.alterarContato.otpCooldownUntil;
export const selectAlterarContatoLoading = (state: RootState) =>
  state.portal.alterarContato.loading;
export const selectAlterarContatoError = (state: RootState) => state.portal.alterarContato.error;

export const selectPortalLoginLookup = (state: RootState) => state.portal.loginLookup;

export const selectPortalRememberHint = (state: RootState) => state.portal.rememberHint;
export const selectPortalRememberHintLoading = (state: RootState) =>
  state.portal.rememberHintLoading;
